module.exports = __webpack_public_path__ + "static/media/panrico@3x.3da6300a.jpg";